module.exports = __webpack_public_path__ + "img/rpc_logo.58911a14.jpg";